export const accent = '#f90000';
export const mainColor = '#52bfd3';
export const textColor = '#52bfd3';
export const pageWidth = '1440px';
